// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"184":"2d751bbb","223":"2a496cb4","453":"2f90484f"}[chunkId] + ".chunk.js");